/**
 * Cabeçalho do card de cobertura — uma tela só, sem aba (PBI #2728, tela unificada). Substitui
 * `TAB_CONTENT`, que tinha um texto por aba (`faturamento`/`demonstracoes`): as duas telas viraram uma
 * só, então o card também virou um só, com um texto fixo.
 */
export const COVERAGE_CARD_CONTENT = {
  eyebrow: 'COBERTURA DOCUMENTAL',
  title: 'Cobertura documental por exercício',
  description:
    'Faturamento mensal, DRE e Balanço de cada exercício da janela obrigatória: 3 anos anteriores + o corrente.',
} as const;
